export class TextTypeReferenceModel {
    public textTypeCode: string;
    public textTypeName: string;
    public textFlag: boolean;
    public maximumLength: number;
    public teletypeFlag: boolean;
    public multipleFlag: boolean;
}